<nz-tag *ngIf="ratio != null" [ngClass]="tagClass" class="a-fx a-fx-start-center a-fx-gap-4" [nz-tooltip]="tooltip">
    <div class="a-fx a-fx-start-center">
        <adspt-icon *ngFor="let check of checks" name="check" />
    </div>

    <span class="a-color-text-primary">{{ ratio | formatPercent: false : 0 }}</span>
</nz-tag>
